export default __webpack_public_path__ + "static/media/fish-min.cb8834be.jpg";